import { render, staticRenderFns } from "./TaxTitle.vue?vue&type=template&id=4928f75d&"
import script from "./TaxTitle.vue?vue&type=script&lang=js&"
export * from "./TaxTitle.vue?vue&type=script&lang=js&"
import style0 from "./TaxTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
